<script lang="ts">
  import { getStr, isMobileWidth } from '../../../../../common/util';
  import Icon from '../../Icon.svelte';

  export let product;
  export let iconMobileWidth = 20;
  export let iconDesktopWidth = 20;

  $: cashback = getProductCashback(product);

  let giftLabel = '';
  $: {
    if (product.freegiftInfo?.sourceQuantiy) {
      giftLabel =
        product.freegiftInfo['sourceQuantiy'] == 1
          ? `${product.freegiftInfo['sourceQuantiy']} ${getStr('extra.pdp.giftlable')}`
          : `${product.freegiftInfo['sourceQuantiy']} ${getStr('extra.pdp.giftslable')}`;
    }
  }
  let offerLabel = '';
  $: if (product.offersCount) {
    if (product.offersCount == 1) {
      offerLabel = `${product.offersCount} ${getStr('extra.pdp.offerlable')}`;
    } else {
      offerLabel = `${product.offersCount} ${getStr('offers')}`;
    }
  }

  function getProductCashback(product) {
    if (product?.hasCashBack === true) {
      return +product.cashback.split('-')[0];
    }
    return 0;
  }
</script>

{#if cashback > 0 || product?.offersCount || (product?.freegiftInfo?.hasFreegift == true && product?.freegiftInfo?.sourceQuantiy?.length > 0)}
  <div class="tile-gift-container" class:isMobile={isMobileWidth()}>
    {#if giftLabel}
      <div class="gift gift-wrapper">
        <Icon glyph="icon-gift-plain" mobileSize={iconMobileWidth} desktopSize={iconDesktopWidth} type="primary" />
        <span class="dot align-middle"> {@html giftLabel}</span>
      </div>
    {/if}
    {#if offerLabel}
      <div class="offer offer-wrapper">
        <Icon glyph="icon-offer-plain" mobileSize={iconMobileWidth} desktopSize={iconDesktopWidth} type="primary" />
        <span class="dot align-middle"> {@html offerLabel}</span>
      </div>
    {/if}
  </div>
{/if}

<style lang="scss">
  @import '../../../styles/colors.new.scss';
  .tile-gift-container {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-top: 10px;
    @include desktop-max-width {
      margin-top: 12.5px;
    }

    .gift,
    .offer {
      font-size: 12px;
      line-height: 14px;
      font-weight: 400;
      display: flex;
      align-items: center;
      gap: 4px;
      color: $neutral-dark-01;
    }
  }
</style>
